import { menusConfig } from '@/common/config';
import { userInfo } from '@/models/userInfo';
import { getCookie } from '@/utils';
import instance from '@/utils/request';
import { CommonMessage } from 'AssetShareComponents';
import qs from 'qs';

interface MaterialListParams {
  url: string;
  method: 'post' | 'get';
  headers?: any;
  query?: any
}
const fetchWeb3dApi = async (params: MaterialListParams) => {
  const {
    url,
    method,
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    query
  } = params;
  let res = await instance?.[method](`${menusConfig}/Web3D.axd?m=${url}`,
    qs.stringify({
      command: url,
      params: JSON.stringify({
        ...query,
        authCode: getCookie('authCode'),
        userId: userInfo?.userId
      })
    }), {
    headers
  })
  if (res.Status === 200 && res.JSON) {
    const data = JSON.parse(res.JSON);
    return {
      records: data?.ReturnList,
      total: data?.TotalResults,
      code: 0,
      // data?.FavoriteMaterial存在才返回
      ...(data?.FavoriteMaterial ? { FavoriteMaterial: data?.FavoriteMaterial } : {})
    }
  } else {
    if (res?.ErrorMessage) {
      // message.error(res?.ErrorMessage)
      CommonMessage({
        type: 'error',
        content: res?.ErrorMessage,
        key: 'web3dApi'
      });
    }
  }
}
export default fetchWeb3dApi
